import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "../translations/Translation.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import { Grid } from "@mui/material";
import TranslationsClient from "../../clients/TranslationsClient";
import { NOTNULL_OR_NOTUNDEFINED } from "../../utils/EmpUtil";
import EMPInputField from "../../shared/components/EMPInputField/EMPInputField";

class TranslationSpecific extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: {},
      oldLanguage: {},
      isEditable: false,
    };
    this.lan = this.props.currentLan;
  }

  componentDidMount() {
    this.setState({ language: this.props.language });
  }

  handleChange = (event) => {
    const { value } = event.target;
    this.setState((prevState) => ({
      language: { ...prevState.language, [this.lan]: value },
    }));
  };

  edit = () => {
    this.setState((prevState) => ({
      isEditable: !prevState.isEditable,
      oldLanguage: prevState.language,
    }));
  };

  cancel = () => {
    this.setState((prevState) => ({
      isEditable: !prevState.isEditable,
      language: prevState.oldLanguage,
    }));
  };

  publish = () => {
    TranslationsClient.updateCurrentTranslations(
      this.lan,
      this.props.moduleKey,
      this.state.language.key,
      this.state.language[this.lan],
      this.props.userDetails.market
    );
    this.setState((prevState) => ({ isEditable: !prevState.isEditable }));
  };

  render() {
    return NOTNULL_OR_NOTUNDEFINED(this.state.language[this.lan]) &&
      !this.state.language[this.lan].startsWith("{") ? (
      <div>
        <Grid container className={styles.lan}>
          <Grid item md={3} className={styles.lanDetails}>
            {this.state.language.key}
          </Grid>
          <Grid item md={3} className={styles.lanDetails}>
            {this.state.language.en}
          </Grid>
          <Grid item md={3} className={styles.lanDetails}>
            {this.state.isEditable ? (
              <div style={{ width: "95%" }}>
                <EMPInputField
                  className={styles.inputFieldspecific}
                  type="text"
                  name="topicBox"
                  multiline
                  value={this.state.language[this.lan]}
                  onChange={this.handleChange}
                />
              </div>
            ) : (
              <Grid item md={3} className={styles.lanDetails}>
                {this.state.language[this.lan]}
              </Grid>
            )}
          </Grid>
          {this.state.isEditable ? (
            <Grid item md={3} className={styles.lanUpdate}>
              <DoneIcon
                fontSize="small"
                style={{ color: "green" }}
                className={styles.button_hover}
                onClick={this.publish}
              />
              <ClearIcon
                fontSize="small"
                style={{ color: "red" }}
                className={styles.button_hover}
                onClick={this.cancel}
              />
            </Grid>
          ) : (
            <Grid item md={3} className={styles.lanUpdate}>
              <EditIcon
                fontSize="small"
                color="primary"
                variant="outlined"
                className={styles.button_hover}
                onClick={this.edit}
              />
            </Grid>
          )}
        </Grid>
      </div>
    ) : null;
  }
}

TranslationSpecific.propTypes = {
  currentLan: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired,
  moduleKey: PropTypes.string.isRequired,
  userDetails: PropTypes.shape({
    market: PropTypes.string,
  }).isRequired,
};

export default TranslationSpecific;
